export default {
  SET_BLOCK_TEMPLATES: '@WS/BLOCK_TEMPLATES/SET_BLOCK_TEMPLATES',
};
